module.exports = __webpack_public_path__ + "img/level2addon_running_mask.8eeb6d5a.png";